import styled from '@emotion/styled';
import DataTable from '../DataTable/DataTable';

// eslint-disable-next-line import/prefer-default-export
export const StyledDataTable = styled(DataTable)({
  marginBottom: 0,
});
